window.SiteReady(($) => {

  console.log('Init Block: Results Gallery');

});